import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';
import type { CatalogOtherCostVariableUpdateInput } from 'gql/graphql';

import { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { updateCatalogOtherCostVariableGql } from '../catalogVariablesQueries';

export const useUpdateOtherVariable = ({
    closeModalHandler,
    updateCatalogVariables,
}: {
    closeModalHandler: () => void;
    updateCatalogVariables: () => void;
}) => {
    const dispatch = useDispatch();

    const [resetUpdateData] = useResetStoreData({ requestId: 'updateCatalogOtherCostVariable' });

    const tempSuccessHandler = useCallback(() => {
        closeModalHandler();
        updateCatalogVariables();
        resetUpdateData(undefined);
    }, [closeModalHandler, resetUpdateData, updateCatalogVariables]);

    const [, updateOtherVariableStatus, , updateOtherVariableRequest] = useRequest({
        requestId: 'updateCatalogOtherCostVariable',
        query: updateCatalogOtherCostVariableGql,
        withEffect: false,
        dependenciesUpdater: tempSuccessHandler,
    });

    const updateOtherVariableHandler = useCallback(
        (input: CatalogOtherCostVariableUpdateInput) => {
            dispatch(updateOtherVariableRequest({ input }));
        },
        [updateOtherVariableRequest, dispatch],
    );

    return useMemo(
        () => ({
            updateOtherVariableStatus,
            updateOtherVariableHandler,
        }),
        [updateOtherVariableHandler, updateOtherVariableStatus],
    );
};
